import { syncEntityStatuses, syncEntityStatusesEnum } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import React, { Fragment } from "react";
import { add } from "sources/syncStatuses";
import { FormTemplate } from "./templates";

const config = {
    version: {
        // select
        label: "Версия",
        inputProps: { name: "version" },
    },
    syncStatus: {
        // select
        label: "Статус",
        inputProps: { name: "syncStatus" },
        options: syncEntityStatuses.filter((item) => item.value !== syncEntityStatusesEnum.NotSynchronized),
    },
    fixedAt: {
        // field
        label: "Время синхронизации",
        inputProps: { name: "fixedAt" },
    },
    externalId: {
        // field
        label: "Внешний ID",
        inputProps: { name: "externalId" },
    },
    comment: {
        // textarea
        label: "Комментарий",
        inputProps: { name: "comment" },
        textarea: true,
    },
    entityId: {},
    entityType: {},
};
const initialState = getInitialStateFromConfig(config);

class AddSyncStatus extends FormTemplate {
    sendRequest = (stateData) => {
        return add([{ ...this.props.data, ...stateData }]);
    };

    renderBodyInner = () => {
        const { version, syncStatus, externalId, comment, fixedAt } = this.props.config;
        return (
            <Fragment>
                {this.renderField(version)}
                {this.renderSelect(syncStatus)}
                {this.renderDateField({ ...fixedAt, inPortal: true })}
                {this.renderField(externalId)}
                {this.renderField(comment)}
            </Fragment>
        );
    };
}

const ConfiguredModal = (props) => {
    if (props.data.externalId) {
        initialState.externalId = props.data.externalId;
    }
    initialState.entityType = props.data.entityType;
    return <AddSyncStatus {...props} config={config} initialState={initialState} />;
};

export default ConfiguredModal;
